import React, { useEffect } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { SVGICONS } from "config";
import { AppleIcon, GooglePay, PlusIconn } from "icons";
import { StoreAction } from "store/actions";
import { useDetectBrowserWallets } from "hooks";
import { PaymentCardsAction } from "store/actions";
import C from "Constants";
import { PaymentMethodAction } from "store/actions";
import { useLang } from "hooks";
import useBrandLosgisticIntegrations from "hooks/useBrandLosgisticIntegrations";
import CardMachine from "icons/CardMachine";
import CashMachine from "icons/CashMachine";
import { getCreditCardObjByOrderType } from "utils/Utils";
import useScrollToBottomPaymentWidget from "hooks/useScrollToBottomPaymentWidget";
import usePayByPaymentMethod from "features/payment-helpers/helpers/payment_helpers/payby/payby.payment";

//TODO: remove this file after delivery and pick up is revamped

const SortPaymentOptions = (paymentOptions) => {
  if (!paymentOptions || paymentOptions?.length <= 0) return [];
  const options = [...paymentOptions];
  const creditCard = options?.find(
    (paymentOption) => paymentOption.paymentType === C.CREDIT_CARD
  );
  if (creditCard) {
    const creditCardIndex = options?.indexOf(creditCard);
    options.splice(creditCardIndex, 1);
    options.unshift(creditCard);
  }
  return options;
};

const RenderCardOption = ({onClick=()=>{}, icon, label, radioChecked})=>{
  return <div className="p4 mb-3 border border-gray-200 mx-4 rounded-md px-4 py-3"
  onClick={onClick}
  >
   <div className="flex justify-between items-center">
  <div className="text-16x font-normal">
   {icon && <span className="me-3">
      {icon}
    </span>}
    {typeof label === "string" ? t(label) : label}
  </div>
  <div className="flex">
    <span className="inline-flex w-6 h-6">
      <input
        type="radio"
        name="Select Type"
        className="hidden"
      />
      <span className="w-6 h-6 inline-flex ">
        {radioChecked? (
          <SVGICONS.RadioCheck color="text-black" />
        ) : (
          <SVGICONS.RadioUnCheck color="text-black" />
        )}
      </span>
    </span>
  </div>
</div> 
  </div>
}

const CheckoutPaymentMethod = ({ paymentOptions, handleSuceessOrderRoute , setcardProcessing , children }) => {
  const dispatch = useDispatch();
  // const params = useParams();
  const { selectedPaymentType , paybyPaymentModalData } = useSelector(
    (state) => state.PaymentMethodReducer
  );
  const scrollToBottom = useScrollToBottomPaymentWidget(selectedPaymentType);
  const { currentLang } = useLang();
  const { integrationsByName } = useBrandLosgisticIntegrations();
  const supportedBrowserWallets = useDetectBrowserWallets();
  const { selectedPayment, selectedStore } = useSelector(
    (state) => state.store
  );
  const { orderType } = useSelector((state) => state.AppReducer);
  const { orderGrossAmount, totalOrdersGrossAmount, isSplitted, split } = useSelector((state) => state?.cart);
  const { ordered } = useSelector((state) => state.order);
  const { process_payby_payment_outlet_based } = usePayByPaymentMethod(setcardProcessing , handleSuceessOrderRoute);


  useEffect(() => {
    resetPaymentType();
  },[])

  const resetPaymentType = () => {
    dispatch(
      PaymentCardsAction.setstripeSelectedCard({
        cardInfo: {},
        isStoredCard: false,
      })
    );
    
    dispatch(PaymentCardsAction.setstripePaymentCards([]));
    dispatch(StoreAction.setSelectedPaymentMethod(null));
    dispatch(PaymentMethodAction.setSelectedPaymentType(null));
    dispatch(PaymentMethodAction.setPaybyPaymentModalData({}));
  };

  const setPaymentMEthod = (payment, type) => {
    dispatch(StoreAction.setSelectedPaymentMethod(payment));
    dispatch(PaymentMethodAction.setSelectedPaymentType(type));
    dispatch(PaymentCardsAction.resetSelectedCards());

    // Create payment intent when PayBy is selected
    if (type === C.WALLET.NEW_CARD && integrationsByName[C.PAYBY]) {
      const amountTobePaid = parseFloat(
        isSplitted
          ? split?.totalAmount
          : ordered.allOrders.length > 0
          ? totalOrdersGrossAmount
          : orderGrossAmount
      ) || 0;

      if (amountTobePaid > 0) {
        process_payby_payment_outlet_based({
          amountTobePaid: amountTobePaid,
          selectedStore: selectedStore,
        });
      }
    }
  };

  const IsONlinePaymentEnabled = (paymentOptions) => {
    if (!paymentOptions || paymentOptions?.length <= 0) return null;
    if (!GetcardText()) return null;

    const creditCard = paymentOptions?.find(
      (paymentOption) => paymentOption.paymentType === C.CREDIT_CARD
    );
    if (creditCard) {
      return creditCard;
    } else return null;
  };
  const GetcardText = () => {
    if (integrationsByName[C.STRIPE] || integrationsByName[C.CHECKOUT_DOT_COM] || integrationsByName[C.PAYBY])
      return t("Add new card");
    if (integrationsByName[C.TELR]) return t("Pay with card");
    return null;
  };

  const paymentTypeMap = {
    [C.CREDIT_CARD]: {
      icon: <PlusIconn color="text-black" />,
      label: () => GetcardText()
    },
    CASH: {
      icon: <CashMachine />,
      label: (method, lang) => method?.[lang ?? "EN"].name
    },
    CARD_MACHINE: {
      icon: <CardMachine />,
      label: (method, lang) => method?.[lang ?? "EN"].name
    }
  };

  return (
    <>
      <div className="bg-white mt-5 py-4 border-t-4 border-gray-200">
        <h4 className="text-outer-space text-17x font-semibold mx-4 mb-4">
          {t("Pay with")}
        </h4>
        {/* apple pay handling by Zeeshan Ahmad */}
        {IsONlinePaymentEnabled(paymentOptions) &&
          integrationsByName[C.STRIPE] && (
            <>
              {supportedBrowserWallets?.applePay && (
                <RenderCardOption
                  onClick={() => {
                    setPaymentMEthod(
                      getCreditCardObjByOrderType(orderType, selectedStore),
                      C.WALLET.APPLE_PAY
                    );
                  }}
                  label="Apple pay"
                  icon={<AppleIcon color="text-black" />}
                  radioChecked={
                    selectedPayment?.paymentType === C.CREDIT_CARD &&
                    selectedPaymentType === C.WALLET.APPLE_PAY
                  }
                />
              )}
              {supportedBrowserWallets?.googlePay && (
                <RenderCardOption
                  onClick={() => {
                    setPaymentMEthod(
                      getCreditCardObjByOrderType(orderType, selectedStore),
                      C.WALLET.GOOGLE_PAY
                    );
                  }}
                  label={"Google Pay"}
                  icon={<GooglePay color="text-black" />}
                  radioChecked={
                    selectedPayment?.paymentType === C.CREDIT_CARD &&
                    selectedPaymentType === C.WALLET.GOOGLE_PAY
                  }
                />
              )}
            </>
          )}

        {IsONlinePaymentEnabled(paymentOptions) &&
          children &&
          children?.length >= 1 &&
          children[0]}

        {SortPaymentOptions(paymentOptions)?.map((paymentMethod, i) => {
          const type = paymentMethod?.paymentType;
          const isCreditCard = type === C.CREDIT_CARD;
          if ((isCreditCard && !GetcardText()) || type === C.PAY_LATER)
            return null;
          const { icon, label } = paymentTypeMap[type] || {};

          return (
            <RenderCardOption
              key={i}
              onClick={() => {
                setPaymentMEthod(
                  paymentMethod,
                  isCreditCard ? C.WALLET.NEW_CARD : C.WALLET.CASH
                )
                if (isCreditCard) scrollToBottom();
              }}
              label={
                typeof label === "function"
                  ? label(paymentMethod, currentLang)
                  : null
              }
              icon={icon}
              radioChecked={
                (selectedPaymentType === C.WALLET.CASH &&
                  type !== C.CREDIT_CARD &&
                  selectedPayment?._id === paymentMethod?._id) ||
                (selectedPayment?.paymentType === C.CREDIT_CARD &&
                  selectedPaymentType === C.WALLET.NEW_CARD &&
                  type === C.CREDIT_CARD)
              }
            />
          );
        })}

        {children && children?.length >= 2 && children[1]}
      </div>
      <div id="payment-methods"></div>
      {/* <dialog id="payment_result_dialog">
        <p id="payment_result_message"></p>
        <button onclick="document.getElementById('payment_result_dialog').close()">
          Close
        </button>
      </dialog> */}
    </>
  );
};

export default CheckoutPaymentMethod;
